import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useMatch } from 'react-router-dom';

import { getUser, toggleAuthModal } from '../../../../store/slices/authSlice';
import UnreadMessagesCounter from '../../../common/UnreadMessagesCounter';
import styles from './styles.module.scss';

const Item = (props) => {
    const { Icon = null, title = '', pathTo = '', onClick = null, isNeedUser = true, unreadMessages = 0 } = props;
    const dispatch = useDispatch();
    const user = useSelector(getUser);
    const isUser = user?.id;
    const isMatch = useMatch(pathTo);
    const { t } = useTranslation();

    const onBtnPress = () => {
        dispatch(toggleAuthModal({ trigger: true, step: 1 }));
    };

    const propsParam = {
        ...(!!pathTo && { to: pathTo }),
        ...(!!onClick && { onClick }),
        ...(!isUser && isNeedUser && { onClick: onBtnPress })
    };

    const Tag = isUser || !isNeedUser ? Link : 'button';

    return (
        <div className={classNames(styles.wrapper, { [styles.isActive]: isMatch })}>
            <div className={styles.icon}>
                {!!unreadMessages && isUser && <UnreadMessagesCounter counter={unreadMessages} />}
                {!!Icon && <Icon />}
            </div>
            <Tag className={styles.link} {...propsParam}>
                {t(title)}
            </Tag>
        </div>
    );
};

export default Item;
